$(function(){
	setupNavbar();
})

function isScrolled(){
	return $('body').scrollTop() > 0 || $('html').scrollTop() > 0;
}

function setupNavbar(){
	$(".dropdown-expand-on-hover").hover(
		function(){ $(this).addClass('open') },
		function(){ $(this).removeClass('open') }
	);
	
	$('.navbar-default').each(function(){
		var t = $(this);
		if(isScrolled() && t.hasClass('white') && (!t.hasClass('always-shadow'))){
			t.addClass('cast-shadow');
		} 
		else t.removeClass('cast-shadow')
		$(window).bind('scroll', function(){
			if(isScrolled() && t.hasClass('white') && (!t.hasClass('always-shadow'))){
				t.addClass('cast-shadow');
				$('.green-after-scrool').addClass('green').removeClass('white');
			} 
			else {
				t.removeClass('cast-shadow');
				if(!t.hasClass('always-shadow')) {
					$('.green-after-scrool').removeClass('green').addClass('white');
				}
			} 
		})
	})
}  